import { observer } from 'mobx-react-lite';
import RegistrationFrame from '../RegistrationFrame';
import { useSearchParams } from 'react-router-dom';
import ConfirmTerm from './ConfirmTerm';
import InputEmail from './InputEmail';
import { STEP_ONE } from '@shared/components/constants/common.constants';
export default observer(function RegistrationStepOne() {
    // hook
    const [params] = useSearchParams();

    const subStep: string | null = params.get('sub');

    // function
    return (
        <RegistrationFrame currentStep={1}>
            {
                Number(subStep) === STEP_ONE.CONFIRM_TERM ? <ConfirmTerm></ConfirmTerm> : <InputEmail />
            }
        </RegistrationFrame>
    );
});
